// Turns whatever someone typed into a safe http(s) URL, or null.
//
// A bare "shopname.com" is what usually gets written down, so a missing
// scheme is assumed to be https. Only http(s) is allowed through: anything
// else — most importantly `javascript:` — returns null, so a stored value
// can never become an executable href.
//
// Shared by the vendor website field and reorder-item product links, and it
// doubles as the cache key for link previews: the Edge Function keys its
// cache on the same normalised href, so both sides must normalise alike.
export function toHttpUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const candidate = /^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : `https://${raw}`;
  try {
    const url = new URL(candidate);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}

// The bit worth showing in a compact list — "shopname.com/vanilla-oil"
// rather than the full href with scheme, tracking params and trailing slash.
export function prettyUrl(value) {
  const href = toHttpUrl(value);
  if (!href) return String(value || '');
  const url = new URL(href);
  const path = url.pathname === '/' ? '' : url.pathname.replace(/\/$/, '');
  return `${url.hostname.replace(/^www\./, '')}${path}`;
}
